export enum Cookie {
  Necessary = 1,
  Performance,
  Functionality,
  Advertising,
}

export const CookieSettingTitle = 'Cookies Settings'

export const CookieList = [
  {
    value: Cookie.Necessary,
    title: 'Operationally Necessary',
    disabled: true,
    defaultChecked: true,
    description:
      'This includes Technologies that allow you access to our Services, applications, and tools that are required to identify irregular website behavior, prevent fraudulent activity, improve security, or allow you to make use of our functionality.',
  },
  {
    value: Cookie.Performance,
    title: 'Performance-Related',
    description:
      'We may use Technologies to assess the performance of our Services, including as part of our analytic practices to help us understand how individuals use our Services.',
  },
  {
    value: Cookie.Functionality,
    title: 'Functionality-Related',
    description:
      'We may use Technologies that allow us to offer you enhanced functionality when accessing or using our Services. This may include identifying you when you sign into our Services or keeping track of your specified preferences, interests, or past items viewed.',
  },
  {
    value: Cookie.Advertising,
    title: 'Advertising or Targeting-Related',
    description:
      'We may use first party or third-party Technologies to deliver content, including ads relevant to your interests, on our Services or on third-party websites.',
  },
]

export const CookieSettingKey = 'avia-cookie-settings'
export const LastUpdateCookieKey = 'avia-cookie-timestamp'
